import React from "react";
import { Paper } from "@material-ui/core";
import { HeaderStyles } from "./header.styles";

export default function Header() {
  const classes = HeaderStyles();
  return (
    <Paper square elevation={6} className={classes.container}>
      <img
        className={classes.logo}
        src="/mentoro_logo.svg"
        alt="Logo Mentoro"
      />
    </Paper>
  );
}
